export default "/images/framework/TutorialEng.e2478127.svg?e2478127";